<template>
  <div class="product-in-focus col-12 col-sm-10 offset-sm-1">
    <p v-if="heading" class="text-lg text-center text-uppercase">
      {{ heading }}
    </p>

    <div class="product-in-focus-content">
      <ProductPreview
        v-if="product"
        :product="product"
      />
      <div class="product-in-focus-text ">
        <p v-if="productTitle" class="product-title text-xl-max">{{ productTitle }}</p>
        <p v-if="text" class="text-lg text-family-secondary">{{ text }}</p>
        <router-link :to="$url(`shop/${product.slug}`)" :title="product.title" class="btn-icon-right mt-2"></router-link>
      </div>

      
    </div>
  </div>
</template>

<script setup>
import ProductPreview from '@/components/shop/ProductPreviewComponent'


defineProps({
  heading: { type: String, default: null },
  productTitle: { type: String, default: null },
  text: { type: String, default: null },
  product: { type: Object, required: true }
})
</script>